import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BillingContext = createContext(null);

export const BillingProvider = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const refresh = useCallback(async () => {
    if (!user) {
      setStatus(null);
      return;
    }
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/billing/status`, { withCredentials: true });
      setStatus(data);
    } catch (e) {
      // Falhou silenciosamente: não bloqueia a UI
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    refresh();
    if (!user) return;
    const id = setInterval(refresh, 5 * 60 * 1000); // re-check a cada 5min
    return () => clearInterval(id);
  }, [user, refresh]);

  // Re-check ao trocar de rota (propaga rapidamente quando admin marca pago)
  useEffect(() => {
    if (user) refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const isBlocked = !!status?.blocked;
  const daysToDue = status?.days_to_due;
  const overdueDays = status?.overdue_days || 0;
  // Banner ativo quando pendente e <= 5 dias do vencimento OU já vencido
  const showBanner = !!status && status.status !== 'paid' && status.status !== 'no_subscription' && (daysToDue == null || daysToDue <= 5);

  return (
    <BillingContext.Provider value={{ status, loading, refresh, isBlocked, daysToDue, overdueDays, showBanner }}>
      {children}
    </BillingContext.Provider>
  );
};

export const useBilling = () => {
  const ctx = useContext(BillingContext);
  if (!ctx) throw new Error('useBilling deve estar dentro de BillingProvider');
  return ctx;
};
